import React, { FC } from "react";
import { Field as RcField } from "rc-field-form";
import { FieldProps } from "rc-field-form/es/Field";
import stl from "./Field.module.scss";

const Field: FC<FieldProps> = (props) => {
  return (
    <RcField {...props}>
      {(fieldProps, meta) => {
        if (!props.children) {
          return null;
        }
        if (!React.isValidElement(props.children)) {
          return props.children;
        }

        const children = React.cloneElement(props.children, {
          ...fieldProps,
          fieldMeta: meta,
        });

        return (
          <div className={stl.field}>
            {children}

            {meta.errors?.map((error) => (
              <div key={error} className={stl.error}>
                {error}
              </div>
            ))}
          </div>
        );
      }}
    </RcField>
  );
};

export default Field;
